import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AdminRoute({ children }) {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();
    const { hotelId } = useParams();

    useEffect(() => {
        async function checkPermissions() {
            if (!currentUser) {
                navigate('/login');
                return;
            }

            try {
                const idTokenResult = await currentUser.getIdTokenResult();
                const adminClaim = idTokenResult.claims.admin === true;
                const staffClaim = idTokenResult.claims.staff === true;
                const isStaffOnly = staffClaim && !adminClaim;

                setIsAdmin(adminClaim);

                if (isStaffOnly) {
                    // Redirect staff-only users to found items registration
                    navigate(`/${hotelId}/found-items/register`);
                    return;
                }

                if (!adminClaim && !staffClaim) {
                    // User has no permissions
                    navigate('/');
                    return;
                }

                setLoading(false);
            } catch (error) {
                console.error('Error checking permissions:', error);
                navigate('/login');
            }
        }

        checkPermissions();
    }, [currentUser, navigate, hotelId]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!isAdmin) {
        return null;
    }

    return children;
} 